import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {IconArrowLeft, IconGenderMale, IconGenderFemale, IconGenderAgender, IconPlus} from "@tabler/icons-react";
import AthletesGroupsMaterial from "../../Components/MainMenu/AthletesGroupsMaterial";


const EquiptmentNew = () => {
    const [selectedGender, setSelectedGender] = useState(""); // Track selected radio

    const { t } = useTranslation();

    return (
        <div className="p-4 flex flex-col h-full relative">
            <div className="flex items-center pb-4 w-full">
                <div className="shrink-0 w-10">
                    <Link to="/athletes/equiptment">
                        <IconArrowLeft className="w-6 h-auto" />
                        <span className="sr-only">{t("athletesEquiptmentNew.backToList")}</span>
                    </Link>
                </div>
                <h1 className="grow text-2xl uppercase text-center font-black transform -skew-x-12 shrink-0">{t("athletesEquiptmentNew.headline")}</h1>
                <div className="shrink-0 w-10"></div>
            </div>
            <div className="grow overflow-y-auto overflow-x-hidden flex flex-col gap-8">
                daishaspd psad  ds
            </div>
        </div>
    );
};

export default EquiptmentNew;